import { ProjectDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { RJSFSchema } from '@rjsf/utils';
import { RelationshipType } from '../../reducer/settings-tree-reducer.types';

export class RelationshipFormSchema {
  static FromFormData(
    hubName: string,
    projectOptions: ProjectDto[],
    relationshipType: RelationshipType = RelationshipType.Unknown
  ): RJSFSchema {
    return {
      properties: {
        hubName: {
          type: 'string',
          title: 'Hub',
          readOnly: true,
          default: hubName
        },
        projectId: {
          type: 'string',
          title: RelationshipFormSchema.RelationshipTypeToFieldLabel(relationshipType),
          ...(projectOptions.length > 0 && {
            oneOf: projectOptions.map((p) => ({
              type: 'string' as const,
              title: p.name,
              enum: [p.id]
            }))
          })
        }
      },
      required: ['projectId']
    };
  }

  static RelationshipTypeToFieldLabel(relationshipType: RelationshipType): string {
    switch (relationshipType) {
      case RelationshipType.AccessedVia:
        return 'Is accessed via';
      default:
        return 'Related project';
    }
  }
}
